// ==============================|| PRESET THEME - THEME SELECTOR ||============================== //

const Theme = (colors) => {
  const { red, brown, campaignOrange, campaignBlue, green, grey } = colors;
  const greyColors = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: brown[0],
      100: brown[1],
      200: brown[2],
      light: brown[3],
      400: brown[4],
      main: brown[5],
      dark: brown[6],
      700: brown[7],
      darker: brown[8],
      900: brown[9],
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: red[0],
      light: red[2],
      main: red[4],
      dark: red[7],
      darker: red[9],
      contrastText
    },
    warning: {
      lighter: campaignOrange[0],
      light: campaignOrange[3],
      main: '#ff9a00',
      dark: campaignOrange[7],
      darker: campaignOrange[9],
      contrastText: greyColors[100]
    },
    info: {
      lighter: campaignBlue[0],
      light: campaignBlue[3],
      main: '#255181',
      dark: campaignBlue[7],
      darker: campaignBlue[9],
      contrastText
    },
    success: {
      lighter: green[1],
      light: green[4],
      main: green[6],
      dark: green[8],
      darker: green[9],
      contrastText
    },
    grey: greyColors
  };
};

export default Theme;
